import React from 'react';
import UserLink from '../../User/Link';
import BasicUserName from '../../User/BasicUserName/';
var ChatUserLink = function (_a) {
    var participant = _a.participant, _b = _a.noLink, noLink = _b === void 0 ? false : _b, _c = _a.showSymbol, showSymbol = _c === void 0 ? true : _c, usernameClassName = _a.usernameClassName, biData = _a.biData;
    var _d;
    var displayData = undefined;
    if (participant) {
        displayData = {
            initials: participant.displayData.initials,
            name: participant.displayData.name,
            image: (_d = participant.displayData.image) === null || _d === void 0 ? void 0 : _d.url,
        };
    }
    if (!displayData) {
        return null; // TODO whats a sane default?
    }
    var user = {
        userId: 0,
        useridUuid: '',
        username: displayData.name,
        usericon: displayData.image || '',
        type: displayData.initials,
        isNewDeviant: false,
    };
    if (noLink) {
        return (React.createElement(BasicUserName, { usernameClassName: usernameClassName, user: user, showSymbol: showSymbol, symbolOpensPopup: false }));
    }
    return (React.createElement(UserLink, { usernameClassName: usernameClassName, user: user, showSymbol: showSymbol, biData: biData }));
};
ChatUserLink.displayName = 'ChatUserLink';
export default ChatUserLink;
//# sourceMappingURL=ChatUserLink.js.map